import { TFunction } from 'i18next';
import * as yup from 'yup';

import { IconValues } from './components/IconDrawerContent';

export const iconValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    icon: yup.mixed(),
    iconToUpload: yup.mixed().required()
  });

export const initialCardValues = (): IconValues => {
  return {
    icon: { id: 0, path: '', isRounded: false, isDefault: true },
    type: 'default',
    iconToUpload: undefined
  };
};
